import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { IBlock } from "../../../framework/src/IBlock";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { makeApiMessage as MakeApiMessage } from "../../../components/src/common";

export const configJSON = require("./config");

export interface IBannerItem {
  id: string;
  type: string;
  attributes: {
    id: number;
    title: string;
    is_active: boolean;
    position: number;
    is_navigable: boolean;
    navigation_type: string | null;
    navigation_id: string | null;
    external_url: string | null;
    start_date: string | null;
    end_date: string | null;
    image_en_url: string | null;
    image_ar_url: string | null;
  };
}
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: {
    navigate: Function;
    getParam: Function;
  };
  id: string;
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  bannerList: Array<IBannerItem>;
  isLoading: boolean;
  // Customizable Area End
}

export interface SS {}

class BannerListController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  bannerListMessageId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
    ];

    this.receive = this.receive.bind(this);
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    const successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (successResponse && requestId === this.bannerListMessageId) {
      this.setState({
        isLoading: false,
        bannerList: successResponse.data || [],
      });
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    this.getBannerListApi();
  }

  getBannerListApi = () => {
    this.setState({ isLoading: true });

    const requestMessage = MakeApiMessage({
      url: configJSON.ApiUrls.bannersList,
      method: "GET",
    });

    this.bannerListMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  // Customizable Area End
}

export default BannerListController;
